module.exports = __webpack_public_path__ + "images/a6094d08d7b3c38447f2f0b7d4965c4f.svg";